import Tokenization from './tokenization';
import { SentenceProps } from '../props';

/** A react component corresponding to a concrete sentence */
function Sentence(props: SentenceProps) {
    if (props.annotationScheme.kind === "text" 
        || props.annotationScheme.kind === "tagging"
        || props.annotationScheme.kind === "mention"
        || props.annotationScheme.kind === "referent") {
            if (props.tokenization) {
                return <Tokenization
                        key={ props.tokenization.uuid.uuidString }
                        annotationScheme={ props.annotationScheme } 
                        activeStructureIds={ props.activeStructureIds }
                        situationMentionSetList={ props.situationMentionSetList }
                        situationSetList={ props.situationSetList }
                        { ...props.tokenization }
                       />;
            } else {
                alert('No tokenization available for ' + props.uuid.uuidString);
                return null;
            }
    } else if (props.annotationScheme.kind === "constituency") {
        alert('Constituency annotations are not currently supported.');
        return null;
    } else {
        alert('Dependency annotations are not currently supported.');
        return null;
    }
}

export default Sentence;